var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3412_1436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15.75V12.75C2.25 12.1567 2.42595 11.5766 2.75559 11.0833C3.08524 10.5899 3.55377 10.2054 4.10195 9.97836C4.65013 9.7513 5.25333 9.69189 5.83527 9.80765C6.41721 9.9234 6.95176 10.2091 7.37132 10.6287C7.79088 11.0482 8.0766 11.5828 8.19236 12.1647C8.30811 12.7467 8.2487 13.3499 8.02164 13.8981C7.79458 14.4462 7.41006 14.9148 6.91671 15.2444C6.42336 15.5741 5.84334 15.75 5.25 15.75H2.25Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.25C13.6094 2.5428 11.5875 3.40811 9.89779 4.75458C8.2081 6.10106 6.91328 7.87875 6.15 9.9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.25C15.4572 4.39064 14.5919 6.41252 13.2454 8.10221C11.8989 9.7919 10.1213 11.0867 8.1 11.85",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95 6.75C9.40737 7.42265 10.5773 8.59263 11.25 10.05",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3412_1436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyling);
export default __webpack_public_path__ + "static/media/styling.f471ad44b77cdf29bcd35f141c74f31b.svg";
export { ForwardRef as ReactComponent };